import { Route, Routes } from "react-router-dom";
import { Toast } from "@heroui/react";
import { StorefrontChrome } from "./components/StorefrontChrome";
import { CategoryPage } from "./pages/CategoryPage";
import { CartPage } from "./pages/CartPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProductPage } from "./pages/ProductPage";
import { SearchPage } from "./pages/SearchPage";
import { StorePage } from "./pages/StorePage";

export function App() {
  return (
    <>
      <Toast.Provider />
      <StorefrontChrome>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="kategori/:slug" element={<CategoryPage />} />
          <Route path="produk/:slug" element={<ProductPage />} />
          <Route path="toko/:slug" element={<StorePage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </StorefrontChrome>
    </>
  );
}
